// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"fb3f15c7","513":"690e2110","703":"d604c6cd","787":"89f76c19"}[chunkId] + ".chunk.js";
};